<template>
    <div>
      <section>
        <div class="section-inner">
          <div class="section-cont">
            <h2>다비치 소식 - 공지/뉴스 </h2>
            <p class="site-path">
              <span>Home</span>&nbsp;&gt;&nbsp;
              <span>What's New</span>&nbsp;&gt;&nbsp;
              <span>다비치 소식 - 공지/뉴스 </span>
            </p>
          </div>

          <app-footer/>
        </div>
      </section>
    </div>
</template>

<script>
import AppFooter from '../../AppFooter.vue';

export default {
  components: { AppFooter },
  name: 'NewsAndNoticeShow',
}
</script>